import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowMenu: Components<Theme>['MuiMenu'] = {
  defaultProps: {},
  styleOverrides: {
    paper: {
      // square variant
      borderRadius: '0',
      // box shadow with custom spread
      boxShadow: '0px 2px 25px 0px rgba(0, 0, 0, 0.15)',
    },
    // currently MuiMenuList cannot be extended through theme,
    //  therefore we are styling it with MuiMenu
    list: {
      maxWidth: '100%',
    },
  },
};
